import type { IconData } from '@stacksjs/iconify-core'

export const text: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 1v2a1 1 0 0 1-2 0V2H7v8h1a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2h1V2H2v1a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1\"/>",
  "width": 12,
  "height": 12,
  "viewBox": "0 0 12 12"
}

export default text
